import React, { ReactNode, Children } from 'react';
import styled from 'styled-components';
import Box from '../Box';
import { Space } from '../../../settings/spaces';
import { ResponsiveProp } from '../utils/responsiveProps';

interface Props {
    children: ReactNode;
    space: ResponsiveProp<Space>;
}

const BoxItem = styled(Box as any)`
    :last-child {
        padding-bottom: 0;
    }
`;

export default function Stack({ children, space }: Props) {
    const stackItems = Children.toArray(children);

    if (stackItems.length <= 1) {
        return <>{stackItems}</>;
    }

    return (
        <Box>
            {stackItems.map((child, index) => (
                <BoxItem key={index} paddingBottom={space}>
                    {child}
                </BoxItem>
            ))}
        </Box>
    );
}
